// extracted by mini-css-extract-plugin
export default {"newUiFaq":"wudDG1","body":"F3nuKV","header":"ZNZcM6","title":"XSaLY3","subtitle":"IdNzTH","item":"m1WsNS","question":"oS2Hg3"};